import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {forkJoin, map} from 'rxjs';

import {ProductFeatureSessionService} from '@app/core/services/product-feature-session.service';

/** قبل از ورود به main، enabled و feedback-pending را در session لود می‌کند. */
export const productFeatureSessionGuard: CanActivateFn = () => {
  const session = inject(ProductFeatureSessionService);

  return forkJoin({
    enabled: session.ensureEnabledLoaded(true),
    pending: session.ensureFeedbackPendingLoaded(true),
  }).pipe(map(() => true));
};
